import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const Breadcrumb = ({ projectId, projectName, moduleId, moduleName, workflowName }) => {
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: 'Projects', path: '/project-landing-dashboard' },
    { label: projectName || 'Project', path: projectId ? `/project/${projectId}/dashboard` : null },
    ...(moduleId ? [{ label: moduleName || 'Module', path: `/project/${projectId}/module/${moduleId}` }] : []),
    ...(workflowName ? [{ label: workflowName, path: null }] : [])
  ];

  return (
    <nav className="bg-card border-b border-border px-6 py-4 shadow-sm">
      <ol className="flex items-center gap-2 text-sm">
        {breadcrumbItems?.map((item, index) => (
          <li key={index} className="flex items-center gap-2">
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground flex-shrink-0" 
              />
            )}
            {item?.path ? (
              <button
                onClick={() => navigate(item?.path)}
                className="text-foreground/70 hover:text-foreground font-medium transition-colors duration-200 hover:underline"
              >
                {item?.label}
              </button>
            ) : (
              <span className="text-foreground font-semibold">
                {item?.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;